import React from 'react';
import Chip from '@mui/material/Chip';

const CustomStatusChip = (props) => {

    const stl = estatus => {
        switch (estatus) {
            // estatus de reportes
            case 'Pendiente': return { backgroundColor: '#ffee58', color: '#000', fontSize: '14px' };
            case 'Confirmado': return { backgroundColor: '#42a5f5', color: '#000', fontSize: '14px' };
            case 'Pagado': return { backgroundColor: '#ab47bc', color: '#FFF', fontSize: '14px' };
            case 'Solicitud almacén': return { backgroundColor: '#ffa726', color: '#000', fontSize: '14px' };
            case 'Entregado': return { backgroundColor: '#26a69a', color: '#fff', fontSize: '14px' };
            case 'Surtido': return { backgroundColor: '#66bb6a', color: '#fff', fontSize: '14px' };
            case 'Cancelado': return { backgroundColor: '#af1310', color: '#fff', fontSize: '14px' };
            case 'Pendiente de validación': return { backgroundColor: '#ffee58', color: '#000', fontSize: '14px' };
            case 'Enviado': return { backgroundColor: '#ffc8dd', color: '#000', fontSize: '14px' };
            case 'En fabricación': return { backgroundColor: '#F25B88', color: '#fff', fontSize: '14px' };
            case 'Pendiente de entrega/recolección': return { backgroundColor: '#CCF244', color: '#000', fontSize: '14px' };
            case 'Pago pendiente': return { backgroundColor: '#c2c2c2ff', color: '#000', fontSize: '14px' };

            case 'Consolidado': return { backgroundColor: '#42a5f5', color: '#000', fontSize: '14px' };

            case 'Validado': return { backgroundColor: '#26a69a', color: '#fff', fontSize: '14px' };

            case 'entrada': return { backgroundColor: '#26a69a', color: '#fff', fontSize: '14px' };
            case 'salida': return { backgroundColor: '#ab47bc', color: '#fff', fontSize: '14px' };

            case 'compra': return { backgroundColor: '#7663F2', color: '#fff', fontSize: '14px' };
            case 'servicio': return { backgroundColor: '#85C8F2', color: '#000', fontSize: '14px' };
            case 'venta': return { backgroundColor: '#CCF244', color: '#000', fontSize: '14px' };
            case 'devolucion': return { backgroundColor: '#F2B705', color: '#000', fontSize: '14px' };
            case 'ajuste de inventario': return { backgroundColor: '#F24B78', color: '#fff', fontSize: '14px' };
            case 'fabricacion': return { backgroundColor: '#165F8C', color: '#fff', fontSize: '14px' };

            case 'Compra': return { backgroundColor: '#7663F2', color: '#fff', fontSize: '14px' };
            case 'Pago de Servicio': return { backgroundColor: '#42a5f5', color: '#000', fontSize: '14px' };
            case 'Pago de Nomina': return { backgroundColor: '#ab47bc', color: '#fff', fontSize: '14px' };
            case 'Pago de Impuestos': return { backgroundColor: '#F24B78', color: '#fff', fontSize: '14px' };
            case 'Pago de Prestamo': return { backgroundColor: '#F2B705', color: '#000', fontSize: '14px' };
            case 'Otro': return { backgroundColor: '#CCF244', color: '#000', fontSize: '14px' };
            case 'Mercado Libre': return { backgroundColor: '#ffee58', color: '#000', fontSize: '14px' };
            case 'Envío': return { backgroundColor: '#ffc8dd', color: '#000', fontSize: '14px' };

            case 'Pendiente por Pagar': return { backgroundColor: '#ffee58', color: '#000', fontSize: '14px' };
            case 'Pagada': return { backgroundColor: '#66bb6a', color: '#fff', fontSize: '14px' };
            case 'Cancelada': return { backgroundColor: '#ef5350', color: '#fff', fontSize: '14px' };

            case '3D Filamento': return { backgroundColor: '#42a5f5', color: '#fff', fontSize: '14px' };
            case '3D Resina': return { backgroundColor: '#ab47bc', color: '#fff', fontSize: '14px' };
            case '3D Resina y Filamento': return { backgroundColor: '#26a69a', color: '#fff', fontSize: '14px' };
            case 'Otros': return { backgroundColor: '#8D6E63', color: '#fff', fontSize: '14px' };

            default: return {}
        }
    }

    const stl2 = estatus => {
        switch (estatus) {
            // estatus de reportes
            case 'Pendiente': return { borderColor: '#ffee58', color: 'palette.text', fontSize: '14px' };
            case 'Confirmado': return { borderColor: '#42a5f5', color: 'palette.text', fontSize: '14px' };
            case 'Pagado': return { borderColor: '#ab47bc', color: 'palette.text', fontSize: '14px' };
            case 'Solicitud almacén': return { borderColor: '#ffa726', color: 'palette.text', fontSize: '14px' };
            case 'Entregado': return { borderColor: '#26a69a', color: 'palette.text', fontSize: '14px' };
            case 'Surtido': return { borderColor: '#66bb6a', color: 'palette.text', fontSize: '14px' };
            case 'Cancelado': return { borderColor: '#ef5350', color: 'palette.text', fontSize: '14px' };
            case 'Pendiente de validación': return { borderColor: '#ffee58', color: 'palette.text', fontSize: '14px' };

            case 'Consolidado': return { borderColor: '#42a5f5', color: 'palette.text', fontSize: '14px' };
            case 'Validado': return { borderColor: '#26a69a', color: 'palette.text', fontSize: '14px' };

            case 'entrada': return { borderColor: '#26a69a', color: 'palette.text', fontSize: '14px' };
            case 'salida': return { borderColor: '#ab47bc', color: 'palette.text', fontSize: '14px' };

            case 'Por Confirmar': return { borderColor: '#ffee58', color: 'palette.text', fontSize: '14px' };

            case 'Efectivo': return { borderColor: '#ffb300', color: 'palette.text', fontSize: '14px' };
            case 'Tarjeta': return { borderColor: '#F25B88', color: 'palette.text', fontSize: '14px' };
            case 'Transferencia': return { borderColor: '#26a69a', color: 'palette.text', fontSize: '14px' };
            case 'Mercado Pago': return { borderColor: '#42a5f5', color: 'palette.text', fontSize: '14px' };
            case 'Cheque': return { borderColor: '#ab47bc', color: 'palette.text', fontSize: '14px' };

            default: return {}
        }
    }

    return (
        <>
            {props.variant === 'outlined' ?
                <Chip
                    size={props.size}
                    label={props.label}
                    className={props.className}
                    style={props.estatus ? stl2(props.estatus) : { borderColor: props.borderColor, color: props.color }}
                    variant={props.variant}
                />
                : <Chip
                    size={props.size}
                    label={props.label}
                    className={props.className}
                    style={props.estatus ? stl(props.estatus) : { backgroundColor: props.backgroundColor, color: props.color }}
                    variant={props.variant}
                />
            }
        </>
    );
}

export default CustomStatusChip;